<!--
    Komponent för etiketter som visas med en ikon, t.ex. en status, preliminärbokning eller annan markering.
    För enhetlig design. Kan utökas med props för t.ex. storlek på ikon vid behov.
-->
<script setup lang="ts">
    import { toRefs } from "vue";

    const props = withDefaults(
        defineProps<{
            icon?: string | null;
            text: string;
            size?: "default" | "small";
        }>(),
        {
            size: "default",
        }
    );

    const { icon, text } = toRefs(props);
</script>

<template>
    <div :class="['icon-label', `size-${size}`]">
        <img v-if="icon" :src="icon" />
        <span>{{ text }}</span>
    </div>
</template>

<style lang="scss" scoped>
    .icon-label {
        display: flex;
        gap: 0.25rem;
        justify-items: center;

        &.size-small {
            img {
                width: 15px;
                height: 15px;
            }

            span {
                font-size: 11px;
                line-height: 14px;
            }
        }
    }
</style>
